import { FixaText } from "@coworker/apprestructured/src/shared/wrappers/FixaText/FixaText";
import { FixaBadge } from "@coworker/apprestructured/src/shared/wrappers/FixaBadge/FixaBadge";
import styles from "./Badge.module.css";

type BadgeProps = {
  text: string;
};

function Badge({ text }: BadgeProps) {
  return (
    <FixaBadge
      className={styles["root"]}
      colour="white"
      label={
        <FixaText textStyle="Label.S">{text.toLocaleUpperCase()}</FixaText>
      }
      size="small"
    />
  );
}
export default Badge;
